/* PhenAprin editorial article: Table of Contents generation + scroll-spy.
   Generates TOC entries from `.pa-article .rte h2`, auto-slugs ids, fills the
   desktop sidebar and mobile collapsible lists, runs IntersectionObserver
   scroll-spy, and gates smooth-scroll behind prefers-reduced-motion. */
(function () {
  function ready(fn) {
    if (document.readyState !== 'loading') {
      fn();
    } else {
      document.addEventListener('DOMContentLoaded', fn);
    }
  }

  function slugify(text, used) {
    var base = text
      .toLowerCase()
      .trim()
      .replace(/[^\w\s-]/g, '')
      .replace(/\s+/g, '-')
      .replace(/-+/g, '-')
      .replace(/^-|-$/g, '');
    if (!base) {
      base = 'section';
    }
    var slug = base;
    var i = 2;
    while (used[slug]) {
      slug = base + '-' + i;
      i += 1;
    }
    used[slug] = true;
    return slug;
  }

  ready(function () {
    var article = document.querySelector('.pa-article');
    if (!article) {
      return;
    }

    var rte = article.querySelector('.article-template__content.rte') || article.querySelector('.rte');
    if (!rte) {
      return;
    }

    var headings = Array.prototype.slice.call(rte.querySelectorAll('h2'));
    var lists = Array.prototype.slice.call(document.querySelectorAll('.pa-toc__list'));

    if (headings.length === 0 || lists.length === 0) {
      // No headings or no TOC containers: hide any empty TOC wrappers.
      document.querySelectorAll('[data-pa-toc]').forEach(function (el) {
        el.style.display = 'none';
      });
      return;
    }

    var used = {};
    var entries = headings.map(function (h) {
      if (!h.id) {
        h.id = slugify(h.textContent || '', used);
      } else {
        used[h.id] = true;
      }
      return { id: h.id, text: (h.textContent || '').trim(), el: h };
    });

    var reduceMotion =
      window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (!reduceMotion) {
      document.documentElement.classList.add('pa-smooth-scroll');
    }

    var allLinks = [];

    lists.forEach(function (list) {
      var frag = document.createDocumentFragment();
      entries.forEach(function (entry) {
        var li = document.createElement('li');
        li.className = 'pa-toc__item';
        var a = document.createElement('a');
        a.className = 'pa-toc__link';
        a.href = '#' + entry.id;
        a.textContent = entry.text;
        a.setAttribute('data-pa-toc-target', entry.id);
        li.appendChild(a);
        frag.appendChild(li);
        allLinks.push(a);
      });
      list.innerHTML = '';
      list.appendChild(frag);
    });

    function setActive(id) {
      allLinks.forEach(function (a) {
        if (a.getAttribute('data-pa-toc-target') === id) {
          a.classList.add('is-active');
        } else {
          a.classList.remove('is-active');
        }
      });
    }

    if ('IntersectionObserver' in window) {
      var visible = {};
      var observer = new IntersectionObserver(
        function (records) {
          records.forEach(function (record) {
            visible[record.target.id] = record.isIntersecting;
          });
          // Pick the first heading (in document order) currently visible.
          for (var i = 0; i < entries.length; i += 1) {
            if (visible[entries[i].id]) {
              setActive(entries[i].id);
              return;
            }
          }
        },
        { rootMargin: '-90px 0px -65% 0px', threshold: 0 }
      );
      entries.forEach(function (entry) {
        observer.observe(entry.el);
      });
    }

    // Close the mobile collapsible TOC after a link is tapped.
    var mobileToc = document.querySelector('.pa-toc--mobile');
    if (mobileToc) {
      mobileToc.addEventListener('click', function (e) {
        var link = e.target.closest('.pa-toc__link');
        if (link) {
          mobileToc.removeAttribute('open');
        }
      });
    }
  });
})();
